import React, {useEffect} from 'react';
import WOMPath from '../../worldOfMovies/WOM.path';
import axios from 'axios';
import {Link, NavLink} from 'react-router-dom';
import {connect, ConnectedProps} from 'react-redux';
import {getAllGenres, getFilters, getPagination} from '../../redux/actions';
import {ReduxState} from '../../redux/interface';
import {makeApiUrl, responseValidator} from '../../scripts/functions';
import {WOMAPI, errorMessages} from '../../worldOfMovies/WOM.api';
import {toast} from 'react-toastify';
import './draweMenu.style.scss';

const DrawerMenu: React.FC<ConnectedProps<typeof connector>> = (
    props: ConnectedProps<typeof connector>
) => {
    const handleResetPage = () => {
        props.dispatch(
            getPagination({
                page: 1,
            })
        );
    };

    const handleResetSearchQuery = () => {
        props.dispatch(
            getFilters({
                ...props.filters,
                query: null,
            })
        );
    };

    const handleResetFilters = () => {
        handleResetPage();
        handleResetSearchQuery();
    };

    useEffect(() => {
        axios.get(makeApiUrl(WOMAPI.genres)).then((response) => {
                if (responseValidator(response)) {
                    props.dispatch(getAllGenres(response.data.genres));
                } else {
                    toast.error(errorMessages.APIError);
                }
            }).catch(() => {
                toast.error(errorMessages.APIError);
            });
    }, []);

    return (
        <div className={`wom-drawer-menu ${!props.drawerMenuStatus ? 'closed' : 'open'}`}>
            <Link to='/' className="wom-menu-logo">
                <span>
                    <i className="material-icons">movie_creation</i>
                    <span> World Of Movies</span>
                </span>
            </Link>
            <div className="wom-menu-items">
                <div className="menu-nav">
                    <span className="title">Discover</span>
                    <div className="nav-item">
                        <NavLink to={WOMPath.movieList('')} exact onClick={handleResetFilters}>
                            <span className="material-icons">verified</span>
                            <span>Popular</span>
                        </NavLink>
                        <NavLink to={WOMPath.movieList('top_rated')} onClick={handleResetFilters}>
                            <span className="material-icons">auto_awesome</span>
                            <span>Top Rated</span>
                        </NavLink>
                        <NavLink to={WOMPath.movieList('upcoming')} onClick={handleResetFilters}>
                            <span className="material-icons">
                                hourglass_empty
                            </span>
                            <span>Upcoming</span>
                        </NavLink>
                    </div>
                </div>
                <div className="separator"></div>
                <div className="menu-nav">
                    <span className="title">Genrse</span>
                    {props.genrse ? (
                        props.genrse.length ? (
                            props.genrse.map((genre) => (
                                <div className="nav-item" key={genre.id}>
                                    <NavLink
                                        onClick={handleResetFilters}
                                        activeClassName="active"
                                        to={WOMPath.movieList(genre.name)}
                                    >
                                        <span className="material-icons">trip_origin</span>
                                        <span>{genre.name}</span>
                                    </NavLink>
                                </div>
                            ))
                        ) : (
                            <div className="empty-state">There is no item.</div>
                        )
                    ) : (
                        <div className="loader sidebar-loader">Loading ...</div>
                    )}
                </div>
            </div>
            <div className="wom-menu-footer">
                <span>
                    Developed by <b>Mahdi Sharifi</b>
                </span>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => {
    return {
        drawerMenuStatus: state.drawerMenuStatus,
        genrse: state.genrse,
        filters: state.filters,
    };
};

const connector = connect(mapStateToProps);
export default connector(DrawerMenu);
